<template>
  <div v-show="isShow" class="wh100 masking">
    <div class="dialog">
      <div class="dialog-left">
        <img class="xm-logo" src="./../assets/img/login-logo.png" alt="logo" />
      </div>
      <div class="dialog-right">
        <div class="w100 clearfix close-div">
          <div @click="isShow = false" class="close-box">
            <i class="iconfont close-icon">&#xe612;</i>
          </div>
        </div>
        <div class="header w100">{{ $t("login.title") }}</div>
        <div class="input-box" ref="focusLogin">
          <div class="icon-box flex-center">
            <img
              style="width: 2.4rem; height: 2.3rem"
              src="./../assets/img/tel-icon.png"
            />
          </div>
          <div class="input-centent">
            <input
              class="wh100"
              @blur.stop="loginEnd"
              @focus="loginEnter"
              :placeholder="$t('login.input_phone')"
              type="tel"
              v-model="phoneNumber"
              maxlength="11"
            />
          </div>
        </div>
        <div class="warn" ref="warnTip">
          <i class="iconfont icon-warn">&#xe616;</i>&ensp;{{ userWarn }}
        </div>
        <div class="input-box no-margin" ref="focusPass">
          <div class="icon-box flex-center">
            <img
              style="width: 1.5rem; height: 1.9rem"
              src="./../assets/img/password.png"
            />
          </div>
          <div class="input-centent">
            <input
              class="wh100"
              :placeholder="$t('login.input_password')"
              type="password"
              v-model="password"
              maxlength="20"
              @blur="passEnd"
              @focus="passEnter"
            />
          </div>
        </div>
        <div class="warn" ref="passwordTip">
          <i class="iconfont icon-warn">&#xe616;</i>&ensp;{{ passWarn }}
        </div>
        <div class="w100 reminder">
          <span @click="goRegister">{{ $t("login.register_now") }}</span>
          <span @click="forgetPassword">{{ $t("login.forget_password") }}</span>
        </div>
        <div class="button" @click="loginBtn">{{ $t("login.login_btn") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isShow: false,
      phoneNumber: "",
      password: "",
      userWarn: this.$t("login.phone_warn"),
      passWarn: this.$t("login.pass_warn"),
    };
  },
  watch: {
    "$i18n.locale"() {
      this.userWarn = this.$t("login.phone_warn");
      this.passWarn = this.$t("login.pass_warn");
    },
  },
  methods: {
    forgetPassword() {
      //找回密码
      this.$EventBus.$emit("findPassword");
      this.isShow = false;
    },
    open() {
      this.isShow = true;
    },
    goRegister() {
      this.isShow = false;
      this.$emit("goLigin");
    },
    loginEnter() {
      //当账号框得到焦点时
      this.$refs.focusLogin.style.borderColor = "var(--primary-color)";
      this.$refs.warnTip.style.visibility = "hidden";
    },
    loginEnd() {
      //当账号框失去焦点时
      if (!this.isShow) return;
      this.$refs.focusLogin.style.borderColor = "#D9D9D9";
      let reg = /^1\d{10}$/;
      if (!reg.test(this.phoneNumber)) {
        this.userWarn = this.$t("login.phone_warn");
        this.$refs.warnTip.style.visibility = "visible";
      } else {
        this.$axios
          .post("/", {
            service: "PCLogin.CheckUserExists",
            user_login: this.phoneNumber,
          })
          .then((response) => {
            let res = response.data.data;
            if (res.code != 0) {
              this.$refs.warnTip.style.visibility = "visible";
              this.userWarn = res.msg;
            }
          });
      }
    },
    passEnter() {
      //当密码框得到焦点时
      this.$refs.focusPass.style.borderColor = "var(--primary-color)";
      this.$refs.passwordTip.style.visibility = "hidden";
    },
    passEnd() {
      //当密码框失去焦点时
      this.$refs.focusPass.style.borderColor = "#D9D9D9";
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
      if (!reg.test(this.password)) {
        this.passWarn = this.$t("login.pass_warn");
        this.$refs.passwordTip.style.visibility = "visible";
      }
    },
    loginBtn() {
      if (this.phoneNumber.length < 1) {
        this.userWarn = this.$t("login.phone_empty");
        this.$refs.warnTip.style.visibility = "visible";
      } else if (this.password.length < 1) {
        this.passWarn = this.$t("login.pass_empty");
        this.$refs.passwordTip.style.visibility = "visible";
      } else if (
        getComputedStyle(this.$refs.warnTip, null).visibility === "visible" ||
        getComputedStyle(this.$refs.passwordTip, null).visibility === "visible"
      ) {
        return;
      } else {
        this.$axios
          .post("/", {
            user_login: this.phoneNumber,
            user_pass: this.password,
            service: "PCLogin.UserLogin",
          })
          .then((response) => {
            let res = response.data.data;
            if (res.code == 0) {
              localStorage.setItem("uid", res.info[0].id); //存储uid
              localStorage.setItem("token", res.info[0].token); //token值getUserInfo
              localStorage.setItem("userInfo", JSON.stringify(res.info[0]));
              this.$store.commit("getUserInfo", res.info[0]); //将登录获得得到的个人信息存进vuex中
              this.isShow = false;
              this.$emit("loginSuccess");
              this.$EventBus.$emit("hide", this.$t("login.login_success"));
            } else if (res.code == "1001") {
              this.$refs.passwordTip.style.visibility = "visible";
              this.passWarn = this.$t("login.pass_error");
            } else {
              this.$EventBus.$emit("hide", {
                type: "error",
                msg: res.info[0].ban_tip,
              });
            }
          });
      }
    },
  },
  mounted() {
    this.$EventBus.$on("loginShow", () => {
      this.open();
    });
  },
};
</script>

<style scoped>
.masking {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.3);
}

.dialog {
  width: 90rem;
  min-height: 50rem;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 3;
  margin-left: -45rem;
  margin-top: -28rem;
  background: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0.1rem 0.1rem 1.3rem 0rem rgba(0, 0, 0, 0.43);
  display: flex;
  overflow: hidden;
}

.close-box {
  position: absolute;
  cursor: pointer;
  float: right;
  top: 1.8rem;
  right: 1.8rem;
}

.header {
  width: 32rem;
  height: 3.9rem;
  line-height: 3.9rem;
  font-size: 1.4rem;
  font-family: Microsoft YaHei;
  color: #39404d;
  text-align: center;
  background: linear-gradient(90deg, #ffc316 4.33%, #fbcb70 122.33%);
  border-radius: 20px;
  margin-top: 8rem;
}

.input-box {
  width: 32rem;
  height: 3.2rem;
  background: #fff;
  margin-top: 3rem;
  display: flex;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  overflow: hidden;
}

.icon-box {
  width: 5.2rem;
  height: 3.2rem;
  background: rgba(236, 233, 233, 0.77);
  border-right: 1px solid #d9d9d9;
  border-radius: 5px 0px 0px 5px;
}

.input-centent {
  width: calc(100% - 4rem);
  height: 100%;
}
.input-centent input {
  padding-left: 1rem;
}
.input-centent > div {
  font-family: Microsoft YaHei;
  color: #ffffff;
  cursor: pointer;
}

.reminder {
  width: 32rem;
  font-size: 1.4rem;
  font-family: Microsoft YaHei;
  color: #b78b0e;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.button {
  width: 32rem;
  height: 4rem;
  line-height: 4rem;
  background: linear-gradient(90deg, #fbdd7f 0%, #fbca6f 98.96%);
  border-radius: 5px;
  text-align: center;
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
  font-size: 1.4rem;
  font-family: Microsoft YaHei;
  color: #39404d;
  cursor: pointer;
}
.dialog-right {
  width: 43.3rem;
  padding-left: 5rem;
}
.dialog-left {
  width: 44.7rem;
  background: url("../assets/img/login-bg.png");
  background-size: 100% 100%;
  color: #fff;
  font-size: 1.4rem;
  text-align: center;
  position: relative;
  left: 0;
  z-index: 1;
}
.download-app {
  margin-top: 2.7rem;
}
.more-game {
  margin-top: 0.6rem;
}
.erweima {
  margin-top: 2.5rem;
  width: 12rem;
  height: 12rem;
}
.system {
  margin-top: 2.5rem;
  font-size: 1.2rem;
}
.xm-logo {
  position: absolute;
  /* width:14.1rem; */
  top: 3.2rem;
  left: 2.6rem;
}
.no-margin {
  margin-top: 0;
}
.warn {
  margin-left: 5rem;
  line-height: 2.4rem;
  height: 3rem;
  color: #fa0505;
  font-size: 1.2rem;
  visibility: hidden;
}
.icon-warn {
  font-size: 1.4rem;
}
.passwordwarn {
  visibility: visible;
  height: 2.4rem;
  display: none;
}
.close-icon {
  color: #94979e;
  font-size: 1.2rem;
}
.close-div {
  position: relative;
  height: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/base/login.vue